"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'users/v1/app/attributes';

var UsersAppAttributesAPI =
/*#__PURE__*/
function () {
  function UsersAppAttributesAPI() {
    (0, _classCallCheck2.default)(this, UsersAppAttributesAPI);
  }

  (0, _createClass2.default)(UsersAppAttributesAPI, null, [{
    key: "set",
    value: function set(_ref) {
      var key = _ref.key,
          value = _ref.value;
      return _apiClient.default.post(BASE_URI, {
        data: {
          key: key,
          value: value
        }
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _apiClient.default.get(BASE_URI);
    }
  }, {
    key: "getOne",
    value: function getOne(_ref2) {
      var key = _ref2.key;
      return _apiClient.default.get(BASE_URI, {
        query: {
          key: key
        }
      });
    }
  }, {
    key: "getSome",
    value: function getSome(_ref3) {
      var keys = _ref3.keys;
      return _apiClient.default.put(BASE_URI + "/bulk-get", {
        data: {
          keys: keys
        }
      });
    }
  }, {
    key: "delete",
    value: function _delete(_ref4) {
      var key = _ref4.key,
          userId = _ref4.userId;
      return _apiClient.default.delete(BASE_URI + "/" + userId + "/" + key);
    }
  }]);
  return UsersAppAttributesAPI;
}();

exports.default = UsersAppAttributesAPI;
module.exports = exports.default;